import React from "react";
import { Modal, Button } from "antd";
import { SmileOutlined } from "@ant-design/icons";

const BookingPaymentSuccessModal = ({ visible, closeSuccessModel }) => {
  return (
    <Modal
      visible={visible}
      onCancel={() => closeSuccessModel()}
      footer={null}
      centered
      width={400}
    >
      {/* Smile icon */}
      <div style={{ textAlign: "center", fontSize: "55px" }}>
        <SmileOutlined />
      </div>

      {/* Success message */}
      <h3 style={{ textAlign: "center" }}>
        <strong>Reservation Successful</strong>
      </h3>
      <p style={{ textAlign: "center" }}>
        Check your email for confirmation and details.
      </p>

      {/* Continue Booking Button */}
      <div style={{ textAlign: "center" }}>
        <Button
          type="primary"
          shape="round"
          onClick={() => closeSuccessModel()}
        >
          Continue Booking
        </Button>
      </div>
    </Modal>
  );
};

export default BookingPaymentSuccessModal;
